export function handleFetchErrors(response) {
    // TODO miten tässä hanskataan serverin virhetilanteet, esim 400 tai 404
    // TODO esitä virhe käyttäjälle jotenkin järkevästi?
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}
